import * as K from "../constants/constants";

export const fetchGlobalSearch = (args)=>{
	const method = "GET";
	const headers = new Headers();
	const url = args.url;
	const query = args.queryString;

	headers.append('Accept', 'application/json');

	let options = {
		headers,
		method
	};

	return fetch(url, options)
		.then( response=>{

			if(response.ok) {
				return response.json();
			} else {
				throw new Error();
			}
		})
		.then( json=>{
			// Add a timestamp to the new data as it comes in.
			json.expires = new Date().setUTCHours( K.HOURS_BEFORE_EXPIRE );

			return json;
		})
		.catch( error=>{
//console.log("error : " , error);
			throw error;
		})
	;

}



// WEBPACK FOOTER //
// ./src/js/api/globalSearch.js